"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DialogModal;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _colorUtils = require("../../utils/colorUtils");

var _utils = require("../../utils/utils");

var _units = require("../../theme/units");

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _Overlay = _interopRequireDefault(require("../Overlay"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dialog = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "DialogModal__Dialog",
  componentId: "sc-1mzcgy3-0"
})(function (_ref) {
  var theme = _ref.theme,
      visible = _ref.visible;
  return (0, _styledComponents.css)(["position:relative;background:", ";border-radius:0.5rem;overflow:hidden;margin:", ";transition:transform 0.1s ease,opacity 0.1s ease;transition-delay:0.1s,0.1s;transform:scale(1.2);opacity:0;", " max-height:calc(100% - ", ");"], theme.color.paper, theme.globalSizes.base, visible && (0, _styledComponents.css)(["transform:scale(1);opacity:1;"]), theme.globalSizes.large);
});
var ContentWrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "DialogModal__ContentWrapper",
  componentId: "sc-1mzcgy3-1"
})(["flex-grow:1;overflow-y:auto;"]);
var ContentSection = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "DialogModal__ContentSection",
  componentId: "sc-1mzcgy3-2"
})(function (_ref2) {
  var contentHeight = _ref2.contentHeight,
      contentWidth = _ref2.contentWidth,
      fadeScroll = _ref2.fadeScroll,
      gap = _ref2.gap;
  return (0, _styledComponents.css)(["max-width:", ";height:", ";", ""], contentWidth, contentHeight, fadeScroll && (0, _styledComponents.css)(["padding-bottom:", "rem;"], (0, _utils.remValue)(_units.globalSizes[gap])));
});
var FooterBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "DialogModal__FooterBox",
  componentId: "sc-1mzcgy3-3"
})(function (_ref3) {
  var fadeScroll = _ref3.fadeScroll,
      theme = _ref3.theme,
      gap = _ref3.gap;
  return (0, _styledComponents.css)(["", ""], fadeScroll && (0, _styledComponents.css)(["margin-top:0;position:relative;&::before{position:absolute;top:", "rem;height:", "rem;left:0;width:100%;background:linear-gradient( to bottom,", " 0,", " ", "rem ) transparent;content:' ';}"], 0 - (0, _utils.remValue)(_units.globalSizes[gap]), (0, _utils.remValue)(_units.globalSizes[gap]), (0, _colorUtils.hexToRGBA)(theme.color.paper, 0), (0, _colorUtils.hexToRGBA)(theme.color.paper, 1), (0, _utils.remValue)(_units.globalSizes[gap])));
});
var PositionedButton = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "DialogModal__PositionedButton",
  componentId: "sc-1mzcgy3-4"
})(["position:absolute;right:", ";top:", ";margin:0;"], _units.globalSizes.small, _units.globalSizes.small);
/**
  The **DialogModal** is a container component that is used to display additional information and interaction opportunities to the user. The `visible` prop determines whether or not the **DialogModal** is visible on the page and when set to `true`, it will appear centered in a fixed position in the window.

  DialogModals have three **sections**:

  * `headerContent` - renders as a `<header>` element at the top of the Modal
  * `children` - are rendered in the central, `contentSection` element, which will scroll if the content's length is longer than the available space
  * `footerContent` is rendered as a `<footer>` element at the bottom of the dialog - it would be expected to usually contain action buttons to ensure they aren't scrolled away by being hidden in the `contentsection` by overlong content

  DialogModals create React `Portals` which expect to live in the application's `<div id="modal-root"></div>` container
 */

var _ref5 = /*#__PURE__*/_react["default"].createElement(_uiIcons.Cross, {
  size: 24
});

function DialogModal(_ref4) {
  var children = _ref4.children,
      _ref4$closeButton = _ref4.closeButton,
      closeButton = _ref4$closeButton === void 0 ? false : _ref4$closeButton,
      contentHeight = _ref4.contentHeight,
      _ref4$contentWidth = _ref4.contentWidth,
      contentWidth = _ref4$contentWidth === void 0 ? _units.globalSizes.measure : _ref4$contentWidth,
      _ref4$fadeScroll = _ref4.fadeScroll,
      fadeScroll = _ref4$fadeScroll === void 0 ? false : _ref4$fadeScroll,
      footerContent = _ref4.footerContent,
      _ref4$gap = _ref4.gap,
      gap = _ref4$gap === void 0 ? 'base' : _ref4$gap,
      headerContent = _ref4.headerContent,
      height = _ref4.height,
      _ref4$onClose = _ref4.onClose,
      onClose = _ref4$onClose === void 0 ? function () {} : _ref4$onClose,
      _ref4$overlay = _ref4.overlay,
      overlay = _ref4$overlay === void 0 ? false : _ref4$overlay,
      _ref4$padding = _ref4.padding,
      padding = _ref4$padding === void 0 ? 'medium' : _ref4$padding,
      _ref4$visible = _ref4.visible,
      visible = _ref4$visible === void 0 ? false : _ref4$visible,
      width = _ref4.width,
      rest = _objectWithoutProperties(_ref4, ["children", "closeButton", "contentHeight", "contentWidth", "fadeScroll", "footerContent", "gap", "headerContent", "height", "onClose", "overlay", "padding", "visible", "width"]);

  var _React$useState = _react["default"].useState(visible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visibleBuffer = _React$useState2[0],
      setVisibleBuffer = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(visible ? 'flex' : 'none'),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      display = _React$useState4[0],
      setDisplay = _React$useState4[1];

  var timer = _react["default"].useRef(null);

  var overlayRef = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    if (visible) {
      document.addEventListener('keydown', handleKeyDown);
      setDisplay('flex');
      clearTimeout(timer.current);
      timer.current = setTimeout(function () {
        return setVisibleBuffer(true);
      }, 50);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      setVisibleBuffer(false);
      clearTimeout(timer.current);
      timer.current = setTimeout(function () {
        setDisplay('none');
      }, 250);
    }

    return function DialogModalCleanUp() {
      document.removeEventListener('keydown', handleKeyDown);
      clearTimeout(timer.current);
    };
  }, [visible]);

  function handleKeyDown(event) {
    if (event.keyCode === 27) onClose(event);
  }

  function handleClickAway(event) {
    if (event.target === overlayRef.current) onClose(event);
  }

  function handleCloseButtonClick(event) {
    onClose(event);
  }

  return /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
    "aria-hidden": display === 'none',
    onClick: handleClickAway,
    visible: visibleBuffer,
    transparent: !overlay,
    display: display,
    ref: overlayRef
  }, /*#__PURE__*/_react["default"].createElement(Dialog, _extends({
    visible: visibleBuffer,
    height: height,
    width: width,
    padding: padding,
    gap: gap
  }, rest, {
    role: "dialog"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    element: "header"
  }, headerContent), /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(ContentSection, {
    contentWidth: contentWidth,
    contentHeight: contentHeight,
    fadeScroll: fadeScroll,
    gap: gap
  }, children)), /*#__PURE__*/_react["default"].createElement(FooterBox, {
    element: "footer",
    fadeScroll: fadeScroll,
    gap: gap
  }, footerContent), closeButton && /*#__PURE__*/_react["default"].createElement(PositionedButton, {
    onClick: handleCloseButtonClick,
    "aria-label": "close dialog",
    icon: _ref5
  })));
}